module.exports = __webpack_public_path__ + "static/assets/48e773c361111dcd9a71ab99b693ef78.svg";